import React, { Component } from "react";
import { connect } from "react-redux";

import { enWebPage, enBrowserType } from "../lib/ConstCommand";
import { setCurrentBrowserType, setCurrentPageType } from "../lib/RabbitmqClient";
import { isAndroidWebView } from "../lib/HandsUpClient";
import { initializeSmartTVMediaTrace } from "../lib/SmartTVMediaTrace";

import {
    getUserListByQRLogIn,
    falseToNeedRetryGetQrUserList,
    initQrLiveInfo
} from "../modules/hiclasstv";

import {
    joinLive
} from "../modules/live";

import {
    logInByQRCode,
    logInBySmartTV,
    logInByGroupSmartTV,
    logOut,
    forceLogOut,
    setLoginMessage,
    toggle_forceLogoutAlertModal
} from "../modules/user";

import MainContainer from "./MainContainer";
import MainAllListContainer from "./MainAllListContainer";

import WebContentTemplate from "../components/template/WebContentTemplate";

import QRLogInWindow from "../components/etc/QRLogInWindow";
import GroupQRLogInWindow from "../components/etc/GroupQRLogInWindow";
import ForceLogoutAlertModal from "../components/user/modal/ForceLogoutAlertModal";

// 260907 망이 없는 동안 로그인 화면이 열리면 명단 요청 자체가 실패한다.
// 라운드 14-B(Wi-Fi 3분 끊기 + 5분 관찰)를 덮도록 10초 x 40회 = 6분 40초.
const RETRY_GET_USER_LIST_DELAY = 10000;
const RETRY_GET_USER_LIST_LIMIT = 40;

class QRLogInContainer extends Component {
    // 20260819 QR 로그인에서 선택한 크롬북 화면 공유 방향 보정값을 라이브 이동 시까지 유지한다.
    rotateCapture = false;

    // 260904 조용한 재로그인은 이 화면에서 한 번만 시도한다.
    isSilentReLoginTried = false;

    // 260907 망 오류로 실패한 명단 요청의 재시도 상태.
    retryGetUserListCount = 0;
    retryGetUserListTimer = null;

    getLivePath = (liveSeq) => this.rotateCapture ? `/live/${liveSeq}?rotateCapture=-90` : `/live/${liveSeq}`;

    // 260907 명단 요청을 한 자리로 모은다. (2)·(5)·재시도(9)가 같은 것을 부른다.
    requestUserList = (tag) => {
        const routeProps = this.props.routeProps;
        if (!routeProps || !routeProps.match || !routeProps.match.params) return;

        const liveSeq = routeProps.match.params.liveSeq;
        if (!liveSeq || liveSeq === "" || parseInt(liveSeq) <= 0) {
            console.log(`QRLogInContainer(${tag}) - can not request getUserListByQRLogIn ... liveSeq => `, liveSeq);
            return;
        }

        let mode = "web";

        if (this.props.currentPageType === enWebPage.GroupSmartTV) {
            mode = "web-group-smarttv";
        }

        if (this.props.currentPageType === enWebPage.SmartTV) {
            mode = "web-smarttv";
        }

        console.log(`QRLogInContainer(${tag}) - have to request getUserListByQRLogIn ... mode[${mode}], liveSeq => `, liveSeq);

        const request = this.props.getUserListByQRLogIn({
            liveSeq: parseInt(liveSeq),
            mode,
        });

        // 260907 createRequestThunk 은 _FAILURE 를 dispatch 한 뒤 다시 throw 한다.
        // 재시도는 리듀서가 세운 isNeedRetryGetQrUserList 로 도므로 여기서는 삼킨다.
        if (request && typeof request.catch === "function") {
            request.catch(() => {});
        }
    }

    componentDidMount() {
        console.log("QRLogInContainer DidMount - set current browserType");
        setCurrentBrowserType(this.props.browserType);
        console.log("QRLogInContainer DidMount - set current pageTyle");
        setCurrentPageType(this.props.currentPageType);

        if (this.props.currentPageType === enWebPage.SmartTV || this.props.currentPageType === enWebPage.GroupSmartTV) {
            const routeProps = this.props.routeProps;
            const liveSeq = routeProps && routeProps.match && routeProps.match.params ? parseInt(routeProps.match.params.liveSeq) : -1;
            // 260806 멤버·그룹 선택 전에 로그인 URL의 개발용 mediaTrace 설정을 현재 탭에 보존한다.
            initializeSmartTVMediaTrace({
                search: routeProps && routeProps.location ? routeProps.location.search : "",
                pageType: this.props.currentPageType,
                liveSeq: Number.isInteger(liveSeq) ? liveSeq : -1,
                receiverSeq: -1
            });
        }

        // console.log("QRLogInContainer(1) - currentPageType, isLoginYn => ", this.props.currentPageType, this.props.isLoginYn);
        // 클래스 입장 후 뒤로 가기했을 경우이므로 로그아웃 처리 ... by hjkim 20220824
        if (this.props.isLoginYn === "Y" && this.props.currentPageType === enWebPage.LiveQRLogin) {
            console.log("QRLogInContainer(1) - have to request logOut ... userSeq => ", this.props.userSeq);
            this.props.logOut({
                userSeq: this.props.userSeq,
                mode: "web",
                isClickLogout: true
            });
        } else {
            // 스마트TV 뒤로 가기했을 경우 데이터 중복 요청 방지용 ... by hjkim 20230403
            if (this.props.isLoginYn === "N") {
                if (isAndroidWebView()) {
                    console.log("call window.showBookmarkButtonArea");
                    window.showBookmarkButtonArea();
                }

                this.requestUserList("2");
            }
        }
    }

    componentWillUnmount() {
        // 260907 화면을 벗어난 뒤 재요청이 돌지 않도록 정리한다.
        if (this.retryGetUserListTimer) {
            clearTimeout(this.retryGetUserListTimer);
            this.retryGetUserListTimer = null;
        }
    }

    shouldComponentUpdate(nextProps) {
        return (JSON.stringify(nextProps) !== JSON.stringify(this.props));
    }

    trySilentReLogin = () => {
        if (this.isSilentReLoginTried) return;
        if (this.props.currentPageType !== enWebPage.LiveQRLogin) return;
        if (this.props.isLoginYn === "Y") return;
        if (this.props.isNeedRetryingLogin) return;   // 강제 로그아웃 재시도가 돌고 있다
        if (!this.props.isRcvQrLoginInfo) return;     // 명단을 아직 못 받았다

        const routeProps = this.props.routeProps;
        const search = routeProps && routeProps.location ? routeProps.location.search : "";
        if (!search || search === "") return;

        const params = new URLSearchParams(search);
        const queryUserID = params.get("userID") || "";
        if (queryUserID === "") return;

        const list_member = this.props.list_member;
        if (!list_member || list_member.length <= 0) return;

        const loginInfo = list_member.find(info => info.userID === queryUserID);
        if (!loginInfo) {
            console.log("trySilentReLogin - 명단에 없다. 넘어간다. userID => ", queryUserID);
            this.isSilentReLoginTried = true;
            return;
        }

        const queryUserNickname = params.get("userNickname") || "";
        const userNickname = queryUserNickname !== "" ? queryUserNickname : loginInfo.userNickname;

        this.isSilentReLoginTried = true;
        console.log("trySilentReLogin - 조용히 다시 들어간다. userID => ", queryUserID, ", userNickname => ", userNickname);

        this.handleSelectedFunc({
            selectedFunc: "LOGIN_BY_QR",
            loginInfo: { ...loginInfo, userNickname }
        });
    }

    componentDidUpdate(prevProps) {
        // 260904 사고로 끊겨 이 화면으로 되돌아온 학생을 조용히 다시 넣는다.
        // 쿼리는 RabbitmqClient 의 resolveNavigationTarget 이 "사고일 때만" 붙인다 —
        // [끝내기]로 나간 학생에게는 쿼리가 없으므로 여기로 오지 않는다.
        // 수업이 이미 끝났으면 list_member 가 비어 find 가 실패하므로 저절로 걸러진다.
        // ⚠ isNeedRetryingLogin(강제 로그아웃 재시도)과 겹치면 로그인 요청이 둘 나가므로 비켜준다.
        this.trySilentReLogin();

        // 260907 망 오류로 명단을 못 받은 경우 망이 돌아올 때까지 다시 부른다.
        // 리듀서가 _FAILURE 에서 isNeedRetryGetQrUserList 를 세우고, 여기서 한 번 받아 내린다.
        // 재시도가 또 실패하면 리듀서가 다시 세우므로 성공하거나 한도에 닿을 때까지 이어진다.
        // ⚠ 서버가 답을 준 경우(수업 없음 등)는 리듀서가 이 플래그를 false 로 두므로 여기 안 온다.
        if (prevProps.isNeedRetryGetQrUserList !== this.props.isNeedRetryGetQrUserList && this.props.isNeedRetryGetQrUserList) {
            this.props.falseToNeedRetryGetQrUserList();

            if (this.retryGetUserListCount < RETRY_GET_USER_LIST_LIMIT) {
                this.retryGetUserListCount++;
                console.log(`QRLogInContainer(9) - 명단 재요청 예약 ... ${this.retryGetUserListCount}/${RETRY_GET_USER_LIST_LIMIT}, ${RETRY_GET_USER_LIST_DELAY}ms 뒤`);

                if (this.retryGetUserListTimer) clearTimeout(this.retryGetUserListTimer);
                this.retryGetUserListTimer = setTimeout(() => {
                    this.retryGetUserListTimer = null;
                    this.requestUserList("9");
                }, RETRY_GET_USER_LIST_DELAY);
            } else {
                console.log(`QRLogInContainer(9) - 명단 재요청 한도(${RETRY_GET_USER_LIST_LIMIT}회) 도달. 멈춘다.`);
            }
        }

        // this.handleLogMessage("currentPageType", prevProps.currentPageType, this.props.currentPageType);
        // this.handleLogMessage("isGotoWebLive", prevProps.isGotoWebLive, this.props.isGotoWebLive);
        // this.handleLogMessage("isRbmqServerConnected", prevProps.isRbmqServerConnected, this.props.isRbmqServerConnected);
        if (prevProps.isLoginYn !== this.props.isLoginYn && this.props.isLoginYn === "Y") {
            if (this.props.currentPageType === enWebPage.SmartTV || this.props.currentPageType === enWebPage.GroupSmartTV) {
                if (this.props.routeProps.match && this.props.routeProps.match.params) {
                    const liveSeq = this.props.routeProps.match.params.liveSeq;
                    if (liveSeq && liveSeq !== "" && parseInt(liveSeq) > 0) {
                        console.log("QRLogInContainer(3) - go to smart tv page ... liveSeq => ", liveSeq);
                        if (this.props.currentPageType === enWebPage.SmartTV) {
                            // this.props.routeProps.history.push(`/smart_view/${liveSeq}`);
                            this.props.routeProps.history.push(`/smarttv/${liveSeq}`);
                        } else {
                            // this.props.routeProps.history.push(`/group_smart_view/${liveSeq}`);
                            this.props.routeProps.history.push(`/group_smarttv/${liveSeq}`);
                        }
                    } else {
                        console.log("QRLogInContainer(3) - go to -1 smart tv page ... liveSeq => ", liveSeq);
                        if (this.props.currentPageType === enWebPage.SmartTV) {
                            // this.props.routeProps.history.push("/smart_view/-1");
                            this.props.routeProps.history.push("/smarttv/-1");
                        } else {
                            // this.props.routeProps.history.push("/group_smart_view/-1");
                            this.props.routeProps.history.push("/group_smarttv/-1");
                        }
                    }
                }
            } else {
                if (this.props.live_info && this.props.live_info.liveSeq > 0 && this.props.live_info.liveName && this.props.live_info.liveName !== "") {
                    console.log("QRLogInContainer(4) - have to request joinLive ... live_info => ", this.props.live_info);
                    this.props.joinLive({
                        liveSeq: this.props.live_info.liveSeq,
                        liveName: this.props.live_info.liveName,
                        userSeq: this.props.userSeq,
                        userNickname: this.props.userNickname,
                        profileImgUrl: this.props.profileImgUrl
                    });
                } else {
                    console.log("QRLogInContainer(4) - can not request joinLive ... live_info => ", this.props.live_info);
                    // 강제 로그아웃 후 로그인 시도하는 경우이므로 login 후 main 페이지로 이동될 것임
                }
            }
        } else {
            // 클래스 입장 후 뒤로 가기했을 경우 로그아웃이 실행되기 때문에 didmount때 받아온 데이터가 모두 사라지므로 로그인 가능 목록 재호출.. by hjkim 20220824
            if (prevProps.isLoginYn !== this.props.isLoginYn && this.props.isLoginYn === "N") {
                // 여기서는 스마트TV, QR로그인 모두 같은 처리를 해야하기 때문에 따로 케이스 구분하지 않음
                this.requestUserList("5");
            }
        }

        if (this.props.currentPageType !== enWebPage.SmartTV) {
            if (prevProps.isNeedRetryingLogin !== this.props.isNeedRetryingLogin && this.props.isNeedRetryingLogin) {
                const { login_info } = this.props;
                console.log("QRLogInContainer(6) - have to request logInByQRCode ... login_info => ", this.props.login_info);
                let timerProc = setTimeout(() => {
                    console.log("QRLogInContainer(timerProc) - logInByQRCode => ", login_info);
                    this.props.logInByQRCode({
                        loginInfo: {
                            userSeq: login_info.userSeq,
                            userNickname: login_info.nickname
                        },
                        userSeq: login_info.userSeq,
                        userKind: this.props.userKind,
                        mode: "web",
                        kind: "qr-login"
                    });
                }, 500);
                // 20260330 연달아서 메서드를 호출해서 자동 로그인에 실패하는 경우가 발생하므로 주석 처리 ... by hjkim
                // this.props.initQrLiveInfo();
            }

            if (prevProps.isGotoWebLive !== this.props.isGotoWebLive && this.props.isGotoWebLive) {
                if (this.props.isRbmqServerConnected && this.props.performLiveSeq > -1) {
                    console.log("QRLogInContainer(7-1) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                    console.log("QRLogInContainer(7-1) - isGotoWebLive is true!!!!! go to live page!!!");
                    this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
                }
            } else {
                if (prevProps.isRbmqServerConnected !== this.props.isRbmqServerConnected && this.props.isRbmqServerConnected) {
                    if (this.props.isGotoWebLive && this.props.performLiveSeq > -1) {
                        if (this.props.performLiveRobotLiveYN === "N") {
                            console.log("QRLogInContainer(7-2) - go to live page ... liveSeq => ", this.props.performLiveSeq);
                            console.log("QRLogInContainer(7-2) - isGotoWebLive is true!!!!! go to live page!!!");
                            this.props.routeProps.history.push(this.getLivePath(this.props.performLiveSeq));
                        }
                    }
                }
            }
        }
    }

    handleSelectedFunc = ({ selectedFunc, loginInfo }) => {
        switch (selectedFunc) {
            case "LOGIN_BY_QR":
                console.log(loginInfo);
                this.logInByQR(loginInfo);
                break;

            case "FORCE_LOG_OUT":
                console.log("FORCE_LOG_OUT - qr");
                this.props.forceLogOut({
                    userSeq: this.props.login_info.userSeq,
                    mode: this.props.browserType === enBrowserType.Web ? "web" : "hiclass"
                });
                break;

            case "FORCE_LOGOUT_ALERT_TOGGLE":
                this.props.toggle_forceLogoutAlertModal();
                break;

            default:
                break;
        }
    }

    handleLogMessage = (propsName, prevProps, thisProps) => {
        console.log(`handleLogMessage() - ${propsName}:) prevProps[${prevProps}], thisProps[${thisProps}]`);
    }

    logInByQR = ({ userID, userSeq, userNickname, groupSeq, list_member, groupName, rotateCapture = false }) => {
        // 20260819 크롬북 화면 공유 방향 보정 선택값을 로그인 완료 후 이동 주소에 반영한다.
        this.rotateCapture = rotateCapture;
        // 20260820 동일한 오류 메시지로 재시도해도 새 로그인 실패로 전달되도록 이전 메시지를 초기화한다.
        this.props.setLoginMessage("", "none");

        if (this.props.currentPageType === enWebPage.SmartTV) {
            if (this.props.routeProps.match && this.props.routeProps.match.params) {
                const liveSeq = this.props.routeProps.match.params.liveSeq;
                this.props.logInBySmartTV({
                    userSeq,
                    liveSeq,
                    userKind: this.props.userKind,
                    list_member: [
                        { userSeq, userID, userNickname }
                    ],
                    mode: "web",
                    kind: "smart-tv-login", 
                });
            }
        } else {
            if (userSeq >= 0) {
                console.log("QRLogInContainer - logInByQR => ", userSeq);
                this.props.logInByQRCode({
                    loginInfo: {
                        userSeq,
                        userNickname
                    },
                    userID,
                    userSeq,
                    userKind: this.props.userKind,
                    mode: "web",
                    kind: "qr-login"
                });
            } else {
                console.log("QRLogInContainer - logInByQR => userSeq is -1 ");
                if (groupSeq > -1) {
                    const liveSeq = this.props.routeProps.match.params.liveSeq;
                    this.props.logInByGroupSmartTV({
                        isSuccessed: true,
                        isLoginSuccess: true,
                        loginInfo: {
                            userSeq,
                            userNickname
                        },
                        userID,
                        userSeq,
                        userKind: this.props.userKind,
                        liveSeq,
                        groupSeq,
                        list_member,
                        groupName,
                        live_info: this.props.live_info,
                        mode: "web",
                        kind: "group-smart-tv-login"
                    });
                }
            }
        }
    }

    render() {
        return (
            <>
                {
                    this.props.isLoginYn === "Y" && this.props.live_info.liveSeq === -1 ?
                        <MainContainer
                            browserType={this.props.browserType}
                            cookies={this.props.cookies}
                            currentPageType={this.props.currentPageType}
                            routeProps={this.props.routeProps}
                        >
                            <WebContentTemplate>
                                <MainAllListContainer
                                    browserType={this.props.browserType}
                                    cookies={this.props.cookies}
                                    currentPageType={this.props.currentPageType}
                                    routeProps={this.props.routeProps} />
                            </WebContentTemplate>
                        </MainContainer> :
                        <>
                            {
                                this.props.currentPageType === enWebPage.GroupSmartTV ?
                                    <GroupQRLogInWindow
                                        live_info={this.props.live_info}
                                        list_member={this.props.list_member}
                                        alertKind={this.props.alertKind}
                                        loginMessage={this.props.loginMessage}
                                        isInvalidRoute={this.props.isInvalidRoute}
                                        currentPageType={this.props.currentPageType}
                                        handleSelectedFunc={this.handleSelectedFunc}
                                    /> :
                                    <QRLogInWindow
                                        live_info={this.props.live_info}
                                        list_member={this.props.list_member}
                                        isLoginDataResolved={this.props.isRcvQrLoginResponse}
                                        loginEntryFailure={this.props.loginEntryFailure}
                                        alertKind={this.props.alertKind}
                                        loginMessage={this.props.loginMessage}
                                        isInvalidRoute={this.props.isInvalidRoute}
                                        currentPageType={this.props.currentPageType}
                                        handleSelectedFunc={this.handleSelectedFunc}
                                    />
                            }
                            <ForceLogoutAlertModal
                                isModalOpened={this.props.isForceLogoutModalOpened}
                                handleSelectedFunc={this.handleSelectedFunc}
                            />
                        </>
                }
            </>
        );
    }
}

export default connect(
    ({ user, hiclasstv, live }) => ({
        isLoginYn                   : user.isLoginYn,

        userSeq                     : user.userSeq,
        userNickname                : user.userNickname,
        profileImgUrl               : user.profileImgUrl,
        userKind                    : user.userKind,

        login_info                  : user.login_info,

        alertKind                   : user.alertKind,
        loginMessage                : user.loginMessage,

        isRbmqServerConnected       : user.isRbmqServerConnected,

        isNeedRetryingLogin         : user.isNeedRetryingLogin,
        isForceLogoutModalOpened    : user.isForceLogoutModalOpened,

        isGotoWebLive               : live.isGotoWebLive,

        performLiveSeq              : live.performLiveInfo.liveSeq,
        performLiveRobotLiveYN      : live.performLiveInfo.robotLiveYN,

        live_info                   : hiclasstv.qrLiveInfo,
        list_member                 : hiclasstv.list_qrLoginMember,
        isRcvQrLoginInfo            : hiclasstv.isRcvQrLoginInfo,
        // 260907 망 오류로 명단을 못 받았을 때 재요청 신호
        isNeedRetryGetQrUserList    : hiclasstv.isNeedRetryGetQrUserList,
        // 20260820 QR 로그인 REST API 응답 수신 여부를 로그인 불가 판정에 사용한다.
        isRcvQrLoginResponse        : hiclasstv.isRcvQrLoginResponse,
        loginEntryFailure           : live.loginEntryFailure,

        isInvalidRoute              : hiclasstv.isInvalidRoute,
    }),
    {
        getUserListByQRLogIn,
        logInByQRCode,
        logInBySmartTV,
        logInByGroupSmartTV,

        joinLive,
        logOut,

        forceLogOut,
        initQrLiveInfo,
        setLoginMessage,
        falseToNeedRetryGetQrUserList,

        toggle_forceLogoutAlertModal
    }
)(QRLogInContainer);
